import { getTokens } from '@repo/single-spa';
import { invariant } from '@repo/utils';

export async function getIdToken() {
  const token = await getTokens();

  invariant(token, 'idToken or access token are not defined');

  return token.idToken;
}

export async function getAccessToken() {
  const token = await getTokens();

  invariant(token, 'idToken or access token are not defined');

  return token.accessToken;
}
